import * as enums from '@/common/helpers/enums'

export default enums.fromValues({
    '木造(W造)': 'W',
    '鉄骨造(S造)': 'S',
    '鉄筋コンクリート造(RC造)': 'RC',
    '鉄骨鉄筋コンクリート造(SRC造)': 'SRC',
    'アルミ造(AL造)': 'AL',
    'コンクリート充填鋼管構造(CFT造)': 'CFT',
    'コンクリートブロック造(CB造)': 'CB'
})
